import { ItemView } from '@glu/core';
import template from './filterBadge.hbs';

export default ItemView.extend({
  template,

  tagName: 'td',

  events: {
    'click .remove-filter': 'handleRemove'
  },

  modelEvents: {
    change: 'render'
  },

  templateHelpers() {
    return {
      filters: this.options.filters.toJSON()
    };
  },

  getFilterModel() {
    const filters = this.options.filters.where({
      field: this.model.get('field')
    }, this);

    return filters;
  },

  handleRemove(e) {
    e.preventDefault();
    e.stopPropagation();

    this.options.masterCollection.trigger(`grid:clear:filter:${this.model.get('field')}`, this);

    const filterModel = this.getFilterModel();

    if (!filterModel) {
      return;
    }

    filterModel.destroy();
  }
});
